// @ts-nocheck
import React, { useState } from "react";

const CitiesManager = ({
  cities,
  addresses,
  cityForm,
  editingCityId,
  onCityFormChange,
  onCitySubmit,
  onCityCancel,
  onCityEdit,
  onCityDelete,
}) => {
  const [openCityMenuId, setOpenCityMenuId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showCityModal, setShowCityModal] = useState(false);

  const normalizedSearch = String(searchTerm || "").trim().toLowerCase();
  const filteredCities = normalizedSearch
    ? cities.filter((cityItem) =>
        String(cityItem.name || "").toLowerCase().includes(normalizedSearch)
      )
    : cities;

  const handleAddClick = () => {
    onCityCancel();
    setShowCityModal(true);
  };

  const handleModalClose = () => {
    onCityCancel();
    setShowCityModal(false);
  };

  const handleSubmit = async () => {
    const didSave = await onCitySubmit();

    if (didSave) {
      setShowCityModal(false);
    }
  };

  const handleEdit = (cityItem) => {
    setOpenCityMenuId(null);
    onCityEdit(cityItem);
    setShowCityModal(true);
  };

  const handleDelete = (cityItem) => {
    setOpenCityMenuId(null);
    onCityDelete(cityItem);
  };

  return (
    <section className="admin-card table-card">
      <div className="table-title-row">
        <h2>Service Areas</h2>
      </div>

      <div className="rate-admin-actions">
        <input
          type="search"
          name="citySearch"
          placeholder="Search service area"
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
        />
        <button type="button" onClick={handleAddClick}>
          Add Service Area
        </button>
      </div>

      <div className="city-grid">
        {filteredCities.length === 0 ? (
          <p>No Cities Found</p>
        ) : (
          filteredCities.map((cityItem, index) => {
            const cityMenuId = cityItem.id || cityItem.name || `city-${index}`;
            const isMenuOpen = String(openCityMenuId) === String(cityMenuId);

            return (
              <article className="city-card-admin" key={cityItem.id || cityItem.name}>
                <div className="city-card-header">
                  <strong>{cityItem.name || "Unnamed city"}</strong>
                  <div className="city-action-menu">
                    <button
                      type="button"
                      className="city-menu-trigger"
                      aria-label={`Actions for ${cityItem.name || "city"}`}
                      aria-expanded={isMenuOpen}
                      onClick={() =>
                        setOpenCityMenuId((current) =>
                          String(current) === String(cityMenuId) ? null : cityMenuId
                        )
                      }
                    >
                      ⋯
                    </button>

                    {isMenuOpen ? (
                      <div className="city-menu-popover">
                        <button type="button" onClick={() => handleEdit(cityItem)}>
                          Edit
                        </button>
                        <button type="button" className="danger" onClick={() => handleDelete(cityItem)}>
                          Delete
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>
                <span>{addresses.filter((address) => address.city === cityItem.name).length} addresses</span>
              </article>
            );
          })
        )}
      </div>

      {showCityModal ? (
        <div className="modal-overlay">
          <section className="admin-modal" role="dialog" aria-modal="true" aria-labelledby="city-modal-title">
            <header className="admin-modal-header">
              <div>
                <span>Service Area</span>
                <h3 id="city-modal-title">{editingCityId ? "Edit service area" : "Add service area"}</h3>
              </div>
              <button type="button" aria-label="Close service area form" onClick={handleModalClose}>
                ×
              </button>
            </header>

            <label className="admin-modal-field">
              <span>City name</span>
              <input
                type="text"
                name="name"
                placeholder="Enter city name"
                value={cityForm.name}
                onChange={(event) => onCityFormChange(event.target.value)}
              />
            </label>

            <div className="admin-modal-actions">
              <button type="button" onClick={handleModalClose}>
                Cancel
              </button>
              <button type="button" className="save-btn" onClick={handleSubmit}>
                {editingCityId ? "Update service area" : "Add service area"}
              </button>
            </div>
          </section>
        </div>
      ) : null}
    </section>
  );
};

export default CitiesManager;
